export default "__VITE_ASSET__BogM0$Ja__"